import axios from "../../js/project-axios.js";

const hasAuth = (appId, config) => {
    config = Object.assign({
        params: {
            appId
        }
    }, config);
    return axios.get("/oauth/hasAuth", config);
};

const grantAndRequestAuth = (appIdAndRevoke, config) => {
    return axios.post("/oauth/grantAndRequestAuth", appIdAndRevoke, config);
};

const getAuthCode = appId => {
    return axios.post("/oauth/getAuthCode", appId);
};

export default {
    hasAuth,
    grantAndRequestAuth,
    getAuthCode
};